import { gql } from "@apollo/client";

export const UPDATE_INVOICE_UPLOAD_DOCUMENT_SERVICE_DETAILS = gql`
  mutation updateInvoiceUploadDocumentServiceDetails(
    $input: UpdateUploadDocumentServiceDetailsInput!
  ) {
    documentHandler {
      updateInvoiceUploadDocumentServiceDetails(input: $input) {
        success
      }
    }
  }
`;
